<template>
  <div>
    <vs-collapse>
      <vs-collapse-item>
        <div slot="header">Kategoriler Listesi</div>
        <div>
          
            <vs-table :data="eslestirmeListesiData" style="height: 720px">
              <template slot="thead">
                <vs-th>Pazaryeri Kategori</vs-th>
                <vs-th>Firma Kategori</vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td>
                    {{ data[indextr].pazaryeriKategori }}
                  </vs-td>
                  <vs-td>
                    {{ data[indextr].kategori1Ad }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
        </div>
      </vs-collapse-item>
    </vs-collapse>
  </div>
</template>
<script>
export default {};
</script>